import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isOpen: false,
    message: '',
    type: '',
};

const snackbarSlice = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {
        hideSnackbar(state) {
            state.isOpen = false;
        },
        setSnackbar(state, action) {
            return action.payload;
        },
    },
});

export const { hideSnackbar, setSnackbar } = snackbarSlice.actions;

export default snackbarSlice.reducer;

export const showError = (message) => setSnackbar({
    isOpen: true,
    message,
    type: 'error',
});

export const showSuccess = (message) => setSnackbar({
    isOpen: true,
    message,
    type: 'success',
});

export const showInfo = (message) => setSnackbar({
    isOpen: true,
    message,
    type: 'info',
});

export const showWarning = (message) => setSnackbar({
    isOpen: true,
    message,
    type: 'warning',
});
